import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Form from "./components/Form";
import styles from "./Login.module.scss";
import background from "assets/images/login_background_blue.png";
import LogoDefault from "components/Logo";

const Login = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    isLoggedIn ? navigate("/") : navigate("/login");
  }, [navigate, isLoggedIn]);

  return (
    <section className={styles.section}>
      <img src={background} alt="background" className={styles.background} />
      <LogoDefault className={styles.logo} />
        <>
          <div className="container">
            <Form />
          </div>
        </>
    </section>
  );
};

export default Login;
